import React from "react";

import { mdiAlert } from "@mdi/js";
import { useTranslation } from "react-i18next";

import ConfirmModal from "../modal/ConfirmModal";

import type { ModalActions } from "../modal/Modal";

interface EncodingWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function EncodingWarningModal({
  isOpen,
  onClose,
  onConfirm,
}: EncodingWarningModalProps): React.JSX.Element {
  const { t } = useTranslation("editor-content");

  const modalActions: ModalActions[] = [
    {
      label: t("encodingWarningModal.cancel"),
      onClick: onClose,
      buttonVariant: "secondary",
      isCloseAfterAction: false,
    },
    {
      label: t("encodingWarningModal.confirm"),
      onClick: onConfirm,
      buttonVariant: "primary",
      isCloseAfterAction: false,
    },
  ];

  return (
    <ConfirmModal
      actions={modalActions}
      iconPath={mdiAlert}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={t("encodingWarningModal.title")}
      variant="secondary"
    >
      {t("encodingWarningModal.body")}
    </ConfirmModal>
  );
}
